import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  token: null,
  isLoggedIn: false,
  userData:[],
  user:[]
};

const authSlice = createSlice({
  name: 'authReducer',
  initialState,
  reducers: {
    loggedInSuccess: (state, action) => {
      state.token = action.payload.token;
      state.isLoggedIn = true;
    },
    setUser: (state, action) => {
      state.userData = action.payload.userData;
      state.user = action.payload.user;
    },
   
    updateUser: (state, action) => {
      state.userData = action.payload.userData;
      
    },
    userAddresses: (state, action) => {
      return {
        ...state,
        userAddresses: Array.isArray(action.payload) ? action.payload : [],
      }
    },
    setResEnv: (state, action) => {
      return {
        ...state,
        env: action.payload,
      }
    },
    loggedOutSuccess: (state) => {
      state.isLoggedIn = false;
      state.token = null;
      state.userAddresses = [];
      state.userData = null;
      state.user = null
    },
    menues: (state, action) => {
      return {
        ...state,
        menues: action.payload,
        menuesTimestamp: Date.now(), // Add timestamp when menu data is updated
      }
    },
    activeMenu: (state, action) => {
      return {
        ...state,
        activeMenu: action.payload,
      }
    },
    allactiveMenues: (state, action) => {
      return {
        ...state,
        allactiveMenues: action.payload,
      }
    },
    menuDocs: (state, action) => {
      return {
        ...state,
        menuDocs: action.payload,
      }
    },
    res: (state, action) => {
      return {
        ...state,
        res: action.payload,
        resTimestamp: Date.now(), // Add timestamp when response data is updated
      }
    },
    checkStore: (state, action) => {
      return {
        ...state,
        checkStore: action.payload,
      }
    },
  },
  
});

export const {
  loggedInSuccess,
  loggedOutSuccess,
  setUser,
  updateUser,
  userAddresses,
  setResEnv,
  menues,
  activeMenu,
  allactiveMenues,
  menuDocs,
  res,
  checkStore


} = authSlice.actions;
export const authReducer = authSlice.reducer;
